import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IAlert, LayoutService } from 'codex-lib';
import { TableSignUserBase } from 'src/app/envelope/model/table-sign-user-base';
import { DateTimeUtil } from 'src/app/util/date-time-util';
import { EnvelopeInfo } from '../../models/envelope-info';
import { Subscription } from '../../models/subscription';
import { VerificationPortalService } from '../../services/verification-portal.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageBase } from '../../../../envelope/model/language';
import { LanguageUtil } from 'src/app/util/language-util';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import * as R from 'ramda';
import { DatetimeFormatLanguageEnum } from 'src/app/enum/datetime-format-language.enum';
import { TenantCustomizationService } from 'src/app/services/tenant-customization.service';
import { VerificationPortalType } from 'src/app/enum/verification-portal-type.enum';

@Component({
  selector: 'app-signature-list-modal',
  templateUrl: './signature-list-modal.component.html',
  styleUrls: ['./signature-list-modal.component.scss']
})
export class SignatureListModalComponent implements OnInit {
  @ViewChild('longContent') modal;
  envelopeInfo: EnvelopeInfo = null;

  tableSignUserBase: TableSignUserBase;
  timezone: string = DateTimeUtil.getCurrentFormatTimezone();
  languageBase: LanguageBase;
  datetimeFormatLanguageEnum = DatetimeFormatLanguageEnum;
  alertOptions: IAlert;
  portalType: VerificationPortalType;

  constructor(private modalService: NgbModal,
    private layoutService: LayoutService,
    private verificationPortalService: VerificationPortalService,
    private translate: TranslateService,
    private tenantCustomizationService: TenantCustomizationService) {
    this.languageBase = new LanguageBase(translate);
  }

  ngOnInit() {}

  showModalListSignature(envelopeInfo: EnvelopeInfo, portalType: VerificationPortalType = 0) {
    this.envelopeInfo = this.formatEnvelope(envelopeInfo);
    this.envelopeInfo = this.setGelocatation(envelopeInfo);
    this.portalType = portalType;
    this.modalService.open(this.modal, { size: 'xl' });
  }

  downloadOriginalFile() {
    this.layoutService.toggleLoading(true);
    this.verificationPortalService.downloadPDF(this.envelopeInfo.verificationCode).then(() => {
      this.layoutService.toggleLoading(false);
    });
  }

  downloadSignedFile() {
    this.layoutService.toggleLoading(true);
    this.verificationPortalService.downloadSignedPDF(this.envelopeInfo.verificationCode).then(() => {
      this.layoutService.toggleLoading(false);
    });
  }

  downloadPrintingFile(withStamp: boolean) {
    this.layoutService.toggleLoading(true);
    this.verificationPortalService.downloadPrintingPDF(this.envelopeInfo.verificationCode, withStamp).then(() => {
      this.layoutService.toggleLoading(false);
    });
  }

  closeModalList() {
    this.modalService.dismissAll();
  }

  isShowSSN(ssn) {
    return LanguageUtil.isCurrentLanguagePT(this.envelopeInfo.language) && (ssn && (ssn !== null || ssn !== ""));
  }

  isShowSSNName(value: string) {
    if (CPFCNPJUtil.isCPF(value)) {
      return this.translate.instant('verificationPortal.listSignaturesPage.CPF');
    }
    if (CPFCNPJUtil.isCNPJ(value)) {
      return this.translate.instant('verificationPortal.listSignaturesPage.CNPJ');
    }
    if (R.pathOr(0, ['length'], value) >= 1) {
      return 'Id';
    }
    return '';
  }

  isShowSSNMask(value: string) {
    if (CPFCNPJUtil.isCPF(value)) {
      return CPFCNPJUtil.formatSsnToCpf(value);
    }
    if (CPFCNPJUtil.isCNPJ(value)) {
      return CPFCNPJUtil.formatSsnToCnpj(value);
    }
    if (R.pathOr(0, ['length'], value) >= 1) {
      return value;
    }
    return '';
  }

  getSignatureTypeKey(signer: Subscription): string {
    if (signer.isDigital) {
      return 'envelope.signatory.signatureType.digital';
    }

    return signer.signatorySelfieBase64
      ? 'envelope.signatory.signatureType.selfie'
      : 'envelope.signatory.signatureType.electronics';
  }

  setAlertOptions(type) {
    return this.alertOptions = {
      type: type == 0 ?'success' : 'warning',
      dismissible: false,
      linkText: '',
    };
  }

  private formatEnvelope(envelope: EnvelopeInfo): EnvelopeInfo {
    envelope.subscriptions = [];

    for (const sub of envelope.eletronicSignatures) {
      const data = Object.assign({}, sub);
      data.isDigital = false;
      data.isGeolocation = data.signatoryGeolocation == null ? false : true;
      envelope.subscriptions.push(data);
    }

    for (const sub of envelope.digitalSignatures) {
      const data = Object.assign({}, sub);
      data.isDigital = true;
      envelope.subscriptions.push(data);
    }
    envelope.subscriptions = envelope.subscriptions.sort((a, b) => (a.signatureDate.datetimeUtc > b.signatureDate.datetimeUtc) ? 1 : -1);

    return envelope;
  }

  private setGelocatation(envelope: EnvelopeInfo): EnvelopeInfo {
    envelope.subscriptions = envelope.subscriptions.map(
      x => ({
        ...x,
        latitude: x.signatoryGeolocation ? x.signatoryGeolocation.split(' ')[0] : '',
        longitude: x.signatoryGeolocation ? x.signatoryGeolocation.split(' ')[1] : ''
      })
    );
    return envelope;
  }
}
